// src/lib/pdf/generateHistoryPdf.js
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

/**
 * Generate history PDF using standard act format
 * Combines all acts into ONE document with ONE total
 */
export function generateHistoryPdf(acts, user) {
    if (!acts || acts.length === 0) {
        alert('Yuklab olish uchun ma\'lumot yo\'q');
        return;
    }

    const doc = new jsPDF({ unit: 'pt', format: 'a4' });
    const pad = 40;

    // Shapka (kak v standartnom akte)
    doc.setFontSize(14);
    // doc.setFont('times', 'bold'); -> Default Helvetica Bold
    doc.setFont('helvetica', 'bold');
    doc.text('Sklad App', pad, 40);

    doc.setFontSize(9);
    // doc.setFont('times', 'normal'); -> Default Helvetica
    doc.setFont('helvetica', 'normal');
    doc.text('Toshkent sh.', pad, 56);

    // Zagolovok
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text('TARIX HISOBOTI', pad, 90);

    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    const today = new Date().toLocaleDateString('uz-UZ');
    doc.text(`${today} y.`, pad, 110);

    let y = 130;
    doc.line(pad, y, 555, y);
    y += 16;

    // Poluchatel
    doc.setFontSize(11);
    doc.text(`Xodim: ${user?.full_name || '-'}`, pad, y);
    y += 18;
    doc.text(`Bo'lim: ${user?.department || '-'}`, pad, y);
    y += 18;
    doc.text(`Xona: ${user?.room_no || '-'}`, pad, y);
    y += 24;

    // Sobiraem VSE tovary iz VSEX aktov v odnu tablitsu
    const allItems = [];
    let itemCounter = 1;

    acts.forEach(act => {
        if (act.items && act.items.length > 0) {
            act.items.forEach(item => {
                allItems.push({
                    num: itemCounter++,
                    name: item.item_name || '-',
                    sku: item.item_sku || '-',
                    qty: Number(item.qty) || 0,
                    price: Number(item.price) || 0,
                    actNo: act.act_no,
                    actDate: new Date(act.created_at).toLocaleDateString('uz-UZ'),
                });
            });
        }
    });

    // Tablitsa (kak v standartnom akte)
    const body = allItems.map(item => {
        const sum = item.qty * item.price;
        return [
            String(item.num),
            item.name,
            `${item.qty} dona`,
            item.sku,
            item.price ? `${formatMoney(item.price)}` : '-',
            item.price ? `${formatMoney(sum)}` : '-',
        ];
    });

    // Obshchaya summa
    const grandTotal = allItems.reduce((sum, item) => sum + (item.qty * item.price), 0);

    autoTable(doc, {
        startY: y + 6,
        head: [['№', 'Nomi', 'Miqdor', 'SKU', 'Narx (UZS)', 'Summa (UZS)']],
        body,
        styles: { fontSize: 10, font: 'helvetica' }, // Eplicitly helvetica
        headStyles: {
            fillColor: [240, 240, 240],
            textColor: 0, // Keep black text for readability
            font: 'helvetica',
            fontStyle: 'bold'
        },
        columnStyles: {
            0: { cellWidth: 30 },
            1: { cellWidth: 200 },
            2: { halign: 'right', cellWidth: 70 },
            3: { cellWidth: 80 },
            4: { halign: 'right', cellWidth: 80 },
            5: { halign: 'right', cellWidth: 80 },
        },
        margin: { left: pad, right: pad },
    });

    y = doc.lastAutoTable.finalY + 24;

    // Itogo (kak v akte)
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.text(`Jami (UZS): ${formatMoney(grandTotal)}`, pad, y);

    y += 30;
    doc.line(pad, y, 555, y);
    y += 20;

    // Podpisi (kak v standartnom akte)
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(11);
    doc.text('Mas\'ul shaxs:', pad, y);
    doc.text('(Imzo)', pad, y + 40);

    doc.text('Xodim:', pad + 250, y);
    doc.text('(Imzo)', pad + 250, y + 40);

    // Sokhranenie
    const filename = `tarix_${user?.full_name || 'user'}_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(filename);
}

function formatMoney(value) {
    return new Intl.NumberFormat('uz-UZ').format(value || 0);
}
